module.exports = __webpack_public_path__ + "static/media/mobile.a2200c7d.jpg";